import React, { useState } from "react";
import "./ForgotPassword.css";
import { useTranslation } from "react-i18next";
import Button from "../../OwlyManage/components/Buttons/Button/Button";

function ForgotPassword({ onCancel }) {
  const { t } = useTranslation("auth");
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("");
    try {
      const resetUrl =
        process.env.NODE_ENV === "production"
          ? process.env.REACT_APP_BASE_URL_PROD + "/api/auth/password-reset/"
          : process.env.REACT_APP_BASE_URL_DEV + "/api/auth/password-reset/";
      const response = await fetch(resetUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });
      const data = await response.json();
      if (response.ok) {
        setStatus(data.message || t("forgot.status_ok"));
      } else {
        setStatus(data.message || t("forgot.status_fail"));
      }
    } catch {
      setStatus(t("forgot.status_network"));
    }
  };

  return (
    <div className="forgot-password-container">
      <form className="forgot-password-form" onSubmit={handleSubmit}>
        <p>{t("forgot.intro")}</p>
        <div className="forgot-password-actions">
          <input
            className="forgot-password-input"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder={t("forgot.email_placeholder")}
            required
          />
          <div className="forgot-password-buttons">
            <Button type="submit" variant="primary" size="md">
              {t("forgot.send")}
            </Button>
            <Button
              type="button"
              variant="primary"
              size="md"
              onClick={onCancel}
            >
              {t("forgot.cancel")}
            </Button>
          </div>
        </div>
        {status && <div className="forgot-password-status">{status}</div>}
      </form>
    </div>
  );
}
export default ForgotPassword;
